module.exports = __webpack_public_path__ + "img/eea2cf5.png";